function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3116",
  "data-name": "Group 3116",
  transform: "translate(14272 -9381)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2080",
  "data-name": "Group 2080",
  transform: "translate(-14272.5 9380.949)"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_Upload_2309143",
  "data-name": "noun Upload 2309143",
  transform: "translate(0.5 0.05)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_70",
  "data-name": "Group 70"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_67",
  "data-name": "Group 67"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_209",
  "data-name": "Path 209",
  d: "M573.953,1203.32H563.719a3.378,3.378,0,0,1,.18.987v8.013a2.968,2.968,0,0,1-2.962,2.96h-8.019a3.375,3.375,0,0,1-.987-.179v17.233a.981.981,0,0,0,.977.987h21.035a.983.983,0,0,0,.987-.987v-28.026A.994.994,0,0,0,573.953,1203.32Zm-6.184,19.306-3.521,4.076c-.03.03-.05.07-.08.1a.525.525,0,0,1-.14.12,1.036,1.036,0,0,1-1.187,0,.443.443,0,0,1-.15-.12.862.862,0,0,0-.08-.1l-3.511-4.067a1,1,0,0,1,.1-1.4l.01-.01a.978.978,0,0,1,1.376.11l1.865,2.163v-5.88a.983.983,0,1,1,1.965.06v5.821l1.855-2.163a1.013,1.013,0,0,1,.748-.339.987.987,0,0,1,.748,1.625Z",
  transform: "translate(-551.93 -1203.32)",
  fill: "#7d9ef1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_69",
  "data-name": "Group 69",
  transform: "translate(0.003 0.002)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_32",
  "data-name": "Path 32",
  d: "M552.926,1213.343h8.04a.991.991,0,0,0,.988-.988v-8.04a.988.988,0,0,0-1.689-.7l-8.04,8.04a.989.989,0,0,0,.7,1.689Z",
  transform: "translate(-551.933 -1203.322)",
  fill: "#7d9ef1"
}))))));

var SvgFile = function SvgFile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 30,
    viewBox: "0 0 23 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/file.5a1baed2.svg";
export { ForwardRef as ReactComponent };